import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getGroupById } from 'actions/groups';
import Modal from 'containers/Modals/Modal';
import GroupAssignmentForm from 'containers/Forms/AssignmentForm/AssignmentForm';
import AssignmentForm from 'containers/Forms/AssignmentForm/MultipleAssignmentForm';

import { Button, Icon, translate } from '@haldor/ui';

class CreateAssignment extends Component {

	constructor(props) {
		super(props);

		this.state = {
			regular: false,
			showGroupAssignment: false,
			group: null
		}
	}

	componentDidMount = async () => {
		if (this.props.groupId != null) {
			let group = await this.props.getGroupById(this.props.groupId, ['members']);
			if (group != null) {
				this.setState({ group: group });
			}
		}
	}

	toggleRegular = (event) => {
		if (event != null) {
			event.preventDefault();
		}

		this.setState({ regular: !this.state.regular });
	}

	toggleGroup = (event) => {
		if (event != null) {
			event.preventDefault();
		}

		this.setState({ showGroupAssignment: !this.state.showGroupAssignment });
	}

	onAssignmentCreated = (created) => {
		if (created) {
			this.props.onCreated(this.props.createdAssignments);
		}

		this.setState({ regular: !this.state.regular });
	}

	onGroupAssignmentCreate = (assignment) => {
		if (assignment != null) {
			this.props.onCreated([assignment]);
		}

		this.setState({ showGroupAssignment: !this.state.showGroupAssignment });
	}

	render() {
		let { group } = this.state;


		if (!this.props.services.haldor) {
			// Shouldnt be able to create assignments if customer doesnt have service for haldor assignments
			return null;
		}

		let section = group;


		if (section == null) {
			return null;
		}

		return (
			<div style={{ display: 'inline-block', marginLeft: '.55rem' }}>
				<Modal
					isOpen={this.state.regular}
					onClose={this.toggleRegular}
					title={this.props.translate('task-create-button')}
				>
					<AssignmentForm
						onAbort={this.onAssignmentCreated}
						editView={false}
						cloneView={false}
						groupId={section.id}
						section={section}
						disablePlanSelector={true}
						planningAssessments={this.props.planningAssessments}
						existingPlanningAssessments={true}
					/>
				</Modal>

				<Modal
					isOpen={this.state.showGroupAssignment}
					onClose={this.toggleGroup}
					title={this.props.translate('create-group-assignment')}
				>

					<GroupAssignmentForm
						editView={false}
						cloneView={false}
						groupId={section.id}
						onAbort={() => this.setState({ showGroupAssignment: false })}
						onCreated={this.onGroupAssignmentCreate}
						disablePlanSelector={true}
						existingPlanningAssessments={true}
						planningAssessments={this.props.planningAssessments}
					/>
				</Modal>

				<div style={{ display: 'flex' }}>
					<Button onClick={this.toggleRegular}>
						<Icon name="Plus" />
						{this.props.translate('Create assignment')}
					</Button>

					<Button style={{ marginLeft: '.55rem' }} onClick={this.toggleGroup}>
						<Icon name="Plus" />
						{this.props.translate('Create group assignment')}
					</Button>
				</div>
			</div>
		)
	}

}

function mapStateToProps(state) {
	return {
		services: state.Services.availableServices,
		translate: translate(state.Languages.translations),
		createdAssignments: state.assignments.newAssignments,
		createdGroupAssignment: state.assignments.newAssignment,
	}
}

export default connect(mapStateToProps, { getGroupById })(CreateAssignment);